import { render } from "./FlashSaleProductComponent.vue?vue&type=template&id=a74c045a"
import script from "./FlashSaleProductComponent.vue?vue&type=script&lang=js"
export * from "./FlashSaleProductComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/product/FlashSaleProductComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a74c045a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a74c045a', __exports__)) {
    api.reload('a74c045a', __exports__)
  }
  
  module.hot.accept("./FlashSaleProductComponent.vue?vue&type=template&id=a74c045a", () => {
    api.rerender('a74c045a', render)
  })

}


export default __exports__